// The words of the screens this feature builds by script, in one table.
//
// The rest of the store takes its wording from the markup: <spring:message> resolves it in the
// reader's language and the page hands it over as data attributes, which is the right way round.
// The two screens below are drawn by script on markup that does not yet carry their words — the
// register and the journal — so the defaults live here, ONCE, and every one of them can be
// overridden from the markup by the same mechanism the browse screen already uses: a
// `data-label-<key>` attribute on the element the screen starts from.
//
// It held four more families of words — the profile families, the chooser beside a tool's result,
// the "fill with…" selector, the counters and the planner. They went with the « keep this in my
// browser » button, which was the only thing that ever wrote what they described.

const DEFAULTS = {
	nothingLeft: 'Nothing left here.',
	// The register and the journal.
	registerTitle: 'My register (Art. 30)',
	journalTitle: 'My ADR journal',
	referencesTitle: 'Cross-references',
	columnIdentifier: 'Identifier',
	columnTitle: 'Title',
	columnStatus: 'Status',
	columnDate: 'Date',
	columnSupersedes: 'Supersedes',
	columnFrom: 'From',
	columnTo: 'To',
	columnVia: 'Via',
	columnKnown: 'Kept here',
	yes: 'yes',
	no: 'no',
	// Exports.
	exportJson: 'JSON',
	exportCsv: 'CSV',
	exportMarkdown: 'Markdown',
};

/**
 * The vocabulary for one screen: the defaults above, each overridden by a `data-label-<key>` found
 * on the element handed in. Written so that the markup wins the moment it has something to say.
 */
export function words(element) {
	const table = { ...DEFAULTS };
	const data = element && element.dataset ? element.dataset : {};
	Object.keys(data).forEach((attribute) => {
		if (!attribute.startsWith('label') || attribute.length <= 'label'.length) return;
		const key = attribute.charAt(5).toLowerCase() + attribute.slice(6);
		if (data[attribute]) table[key] = data[attribute];
	});
	return table;
}

export { DEFAULTS };
